export class Line {
    text: string;
    lineNumber: number;

    constructor(text: string, lineNumber: number) {
        this.text = text;
        this.lineNumber = lineNumber;
    }
}